export const tooltipTexts = {
  orderId: 'This is the marketplace order id as synced from the source',
  orderAge:
    'This is the time elapsed from when the order was first  created at the source marketplace',
  marketplace:
    'The marketplace source where the order originated. If the order was manually created, we will display the Skupreme icon.',
  organization:
    'The organization source where the order originated. If the order was manually created, we will display the Skupreme icon.',
  totalItems: 'The total number of units in the order',
  totalPrice:
    'The subtotal price of items in the order. This does not include shipping, taxes, fees, etc.',
  locationPriorityInfo:
    'Location priorities guide allocation sequence—starting with lowest priority locations first. This optimizes inventory flow and warehouse efficiency.',
  unitConversionInfo:
    'You can view information in your preferred measurement system. SKUPREME automatically converts measurements sent depending on destination location.',
  shipInBox:
    'If Ships in Product Packaging is selected, we will always ship the item in its own box as it is',
  singleFirstPackaging:
    'Adapts packaging based on order quantity: uses product packaging for single items, selects optimal boxes for multiple units or mixed orders to maximize shipping efficiency.',
  mailer: `Uses item's exact dimensions to ensure carriers rate based on the solid frame, specifically designed for flat envelopes and mailer packages.`,
  noSippingPreference:
    'Automatically selects the optimal box size for your order, applied to both single items and multiple units to maximize shipping efficiency.',
  strappedBundle:
    'Items marked for this config are banded together for shipment. Label dims follow linear mailer sizing, stacking height for total depth. If only one item, it ships as-is using its own packaging or mailer.',
  publicStatusSettings:
    'Marking Public will make warehouse integrations publicly accessible on the ERP portal',
  singleUnitPicking:
    'Orders with single unit items that are not ship in product packaging will be batched into their own waves. They will be picked into a pallet as opposed to a tote.',
  stateInfo:
    'Enter a 2-character state abbreviation (e.g., CA, NY) to prevent fulfillment issues.',
  waveTypeMerging:
    'You cannot merge waves of different types, the exception is Multi-Item Orders and Single-Item Orders.',
};

export const calculationToolTips = {
  cbm: 'It is the total volume of all cartons summed up in Cubic Meters',
  cbf: 'It is the total volume of all cartons summed up in Cubic Feet',
};

export const warehouseTooltips = {
  shipnode:
    'ShipNode is a native application for macOS and Windows that connects your computer and its printers, integrating them with your SKUPREME account. With ShipNode, any user within your workspace can easily print labels directly from their computer, streamlining your shipping processes and enhancing efficiency.',
};
